import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { LoggingService } from '../../../../suche-lib/src/lib/services/logging.service';

/**
 * Service zum Setzen der Robots-Anweisung, ob diese die Seite (bzw. den Seitenzustand inkl. URL-Parametern)
 * zum Suchmaschinen-Index hinzufügen sollen (index / noindex)<br/>
 * sowie ob Link gefolgt werden soll (follow / nofollow)<br/>
 * Eingeführt im Rahmen von @NOWSUCHE-3991 als externe SpamBots manipulierte URLs unserer Anwendung in den Google-Index
 * pushen wollten und damit das Crawl-Budget von arbeitsagentur.de bzw. mein-now.de überforderten (K12-SEO)
 */
@Injectable({
  providedIn: 'root'
})
export class RobotsService {
  private readonly logger = inject(LoggingService);

  private readonly meta = inject(Meta);

  public setIndexFollow() {
    this.meta.updateTag({ name: 'robots', content: 'index,follow' });
    this.logger.debug('INDEX');
  }

  public setNoIndexNoFollow() {
    this.meta.updateTag({ name: 'robots', content: 'noindex,nofollow' });
    this.logger.debug('NOindex');
  }
}
